import React, { useState } from "react";
import { Box } from "@vapor/react-material/Box";
import { Card } from "@vapor/react-material/Card";
import { CardContent } from "@vapor/react-material/CardContent";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Button } from "@vapor/react-material/Button";
import VaporIcon from "@vapor/react-icons/VaporIcon";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import {
  dummyData,
  dummyData2,
  dummyData3,
} from "../../../../assets/DummyData.tsx";
import CustomPopover from "./CustomPopover.tsx";

const DataCard = () => {
  const [selectedCard, setSelectedCard] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleCardClick = (
    data: number | null,
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setSelectedCard(data);
    console.log({ data });
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box>
        {dummyData.map((data) => (
          <div key={data.id}>
            <Card
              style={{
                border: selectedCard === data.id ? "2px solid #00BFFF" : "none",
                height: 70,
              }}
            >
              <CardContent>
                <Box display="flex" justifyContent="space-between">
                  <Box marginTop="12px">{data.logo}</Box>
                  <Typography marginRight="18rem">
                    <strong>{data.title}</strong>
                  </Typography>
                  <Button onClick={(event) => handleCardClick(data.id, event)}>
                    <VaporIcon icon={faEllipsisVertical} color="interactive" />
                  </Button>
                </Box>
                <Typography
                  fontSize="12px"
                  marginTop="-18px"
                  marginLeft="2.5rem"
                >
                  {data.content}
                </Typography>
              </CardContent>
            </Card>
            {selectedCard === data.id && (
              <CustomPopover anchorEl={anchorEl} onClose={handleClosePopover} />
            )}
          </div>
        ))}
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
          }}
        >
          <Typography
            fontSize="14px"
            color="primary.interactiveDefault"
            marginLeft="18px"
          >
            Cantina On Line
          </Typography>
        </Box>
        {dummyData2.map((data) => (
          <div key={data.id}>
            <Card
              style={{
                border: selectedCard === data.id ? "2px solid #00BFFF" : "none",
                height: 70,
              }}
            >
              <CardContent>
                <Box display="flex" justifyContent="space-between">
                  <Box marginTop="12px">{data.logo}</Box>
                  <Typography marginRight="18rem">
                    <strong>{data.title}</strong>
                  </Typography>
                  <Button onClick={(event) => handleCardClick(data.id, event)}>
                    <VaporIcon icon={faEllipsisVertical} color="interactive" />
                  </Button>
                </Box>
                <Typography
                  fontSize="12px"
                  marginTop="-18px"
                  marginLeft="2.5rem"
                >
                  {data.content}
                </Typography>
              </CardContent>
            </Card>
            {selectedCard === data.id && (
              <CustomPopover anchorEl={anchorEl} onClose={handleClosePopover} />
            )}
          </div>
        ))}
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
          }}
        >
          <Typography
            color="primary.interactiveDefault"
            fontSize="14px"
            marginLeft="18px"
          >
            TSE
          </Typography>
        </Box>
        {dummyData3.map((data) => (
          <div key={data.id}>
            <Card
              style={{
                border: selectedCard === data.id ? "2px solid #00BFFF" : "none",
                height: 70,
              }}
            >
              <CardContent>
                <Box display="flex" justifyContent="space-between">
                  <Box marginTop="12px">{data.logo}</Box>
                  <Typography marginRight="18rem">
                    <strong> {data.title}</strong>
                  </Typography>
                  <Button onClick={(event) => handleCardClick(data.id, event)}>
                    <VaporIcon icon={faEllipsisVertical} color="interactive" />
                  </Button>
                </Box>
                <Typography
                  fontSize="12px"
                  marginTop="-18px"
                  marginLeft="2.5rem"
                >
                  {data.content}
                </Typography>
              </CardContent>
            </Card>
            {selectedCard === data.id && (
              <CustomPopover anchorEl={anchorEl} onClose={handleClosePopover} />
            )}
          </div>
        ))}
      </Box>
    </div>
  );
};

export default DataCard;
